import { jsx as _jsx } from "react/jsx-runtime";
import { useResolvedPath } from '@rocketlane/rocket-router';
import { useWithAccess } from 'hooks/rbac/useWithAccess';
import { NotFound } from './404';
import { CustomSecureRoute } from './custom-secure-route';
export const SecureRoute = (props)=>{
    const { rule, resourceData, ...rest } = props;
    const { hasAccessToResource, isLoading } = useWithAccess();
    const path = useResolvedPath('.');
    return rule == null || hasAccessToResource({
        rule,
        resourceData
    }) ? /*#__PURE__*/ _jsx(CustomSecureRoute, {
        ...rest,
        path: path.pathname,
        isLoading: isLoading
    }) : /*#__PURE__*/ _jsx(NotFound, {});
};
